/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';


export interface RefreshOAuthAppValidityOperatorSpec { 
    /**
     * Organisation Id.
     */
    org_id: string;
    service_type?: ServiceTypeEnum;
}
export namespace RefreshOAuthAppValidityOperatorSpec {
}


